export enum actionTypes {
  INDUSTRIAS_FETCH = 'INDUSTRIAS_FETCH',
  INDUSTRIAS_SUCCESS = 'INDUSTRIAS_SUCCESS',
  INDUSTRIAS_ERROR = 'INDUSTRIAS_ERROR',
  INDUSTRIAS_RESET = 'INDUSTRIAS_RESET',
}

export enum IndustriasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Industria {
  id: number
  nombre: string
}

export interface IndustriasState {
  status: IndustriasStatus
  industrias: Array<Industria>
}

export interface IndustriasFetch {
  type: typeof actionTypes.INDUSTRIAS_FETCH
  payload: null
}

export interface IndustriasSuccess {
  type: typeof actionTypes.INDUSTRIAS_SUCCESS
  payload: Array<Industria>
}

export interface IndustriasError {
  type: typeof actionTypes.INDUSTRIAS_ERROR
  payload: null
}

export interface IndustriasReset {
  type: typeof actionTypes.INDUSTRIAS_RESET
  payload: null
}

export type IndustriasActions = IndustriasFetch | IndustriasSuccess | IndustriasError | IndustriasReset

export const initialState: IndustriasState = {
  status: IndustriasStatus.Idle,
  industrias: [],
}
